module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-chevy-24.6a75f1cd.jpg";